import TestImage from "Assets/Images/Reports/test.svg";
import BusImage from "Assets/Images/Reports/bus.svg";
import CameraImage from "Assets/Images/Reports/camera.svg";
import CrossRoadImage from "Assets/Images/Reports/crossroad.svg";
import AccidentImage from "Assets/Images/Reports/accident.svg";
import TrafficImage from "Assets/Images/Reports/traffic_jam.svg";
import ParkingImage from "Assets/Images/Reports/parking.svg";
import RatingImage from "Assets/Images/Reports/ratings.svg";
import SubwayImage from "Assets/Images/Reports/subway.svg";
import TaxiImage from "Assets/Images/Reports/taxi.svg";

import PlusImage from "Assets/Images/Reports/subReports/plus.svg";

import TaxiGeneralStatistics from "Assets/Images/Reports/subReports/taxi/General_statistics.svg";
import Taxierformance from "Assets/Images/Reports/subReports/taxi/performance.svg";
import TaxiDriver from "Assets/Images/Reports/subReports/taxi/driver.svg";
import TaxiActivity from "Assets/Images/Reports/subReports/taxi/Taxi_activity.svg";
import TaxiTravels from "Assets/Images/Reports/subReports/taxi/taxi_travel.svg";
import TaxiLineStatus from "Assets/Images/Reports/subReports/taxi/line_status.svg";
import TaxiBestDrivers from "Assets/Images/Reports/subReports/taxi/best_drivers.svg";
import TaxiCircle from "Assets/Images/Reports/subReports/taxi/circle_taxi.svg";

import DoughnutChart from "Assets/Images/Reports/subReports/bus/doughnut_chart.svg";
import Timezone from "Assets/Images/Reports/subReports/bus/timezone.svg";
import TimelineSlider from "Assets/Images/Reports/subReports/bus/timeline_slider.svg";
import Polyline from "Assets/Images/Reports/subReports/bus/polyline.svg";
import MapPinpoint from "Assets/Images/Reports/subReports/bus/map_pinpoint.svg";
import Traveler from "Assets/Images/Reports/subReports/bus/traveler.svg";

import MetroStatistics from "Assets/Images/Reports/subReports/metro/statistics.svg";
import MetroLineProfile from "Assets/Images/Reports/subReports/metro/lineProfile.svg";
import MetroCompare from "Assets/Images/Reports/subReports/metro/compare.svg";
import MetroMonitoring from "Assets/Images/Reports/subReports/metro/monitoring.svg";
import MetroTime from "Assets/Images/Reports/subReports/metro/time.svg";
import MetroSrcDes from "Assets/Images/Reports/subReports/metro/srcDes.svg";

import TravelReportMatris from "Assets/Images/Reports/subReports/travelReport/matris.svg";
import TravelReporRequest from "Assets/Images/Reports/subReports/travelReport/request.svg";
import TravelReporTime from "Assets/Images/Reports/subReports/travelReport/time.svg";
import TravelReporBus from "Assets/Images/Reports/subReports/travelReport/bus.svg";

import TrafficAndTravelTraffic from "Assets/Images/Reports/subReports/trafficAndTravel/traffic.svg";
import TrafficAndTravelTime from "Assets/Images/Reports/subReports/trafficAndTravel/time.svg";
import TrafficAndTravelVoluminousPassges from "Assets/Images/Reports/subReports/trafficAndTravel/voluminousPassges.svg";
import TrafficAndTravelPredictTime from "Assets/Images/Reports/subReports/trafficAndTravel/predictTime.svg";
import TrafficAndTravelPassageProfile from "Assets/Images/Reports/subReports/trafficAndTravel/passageProfile.svg";

import CrossMoment from "Assets/Images/Reports/subReports/cross/moment.svg";
import CrossStopstatistics from "Assets/Images/Reports/subReports/cross/stopstatistics.svg";
import CrossStopTime from "Assets/Images/Reports/subReports/cross/stopTime.svg";

import MarginParkGeneral from "Assets/Images/Reports/subReports/marginPark/general.svg";
import MarginParkPassage from "Assets/Images/Reports/subReports/marginPark/passage.svg";
import MarginParkIncome from "Assets/Images/Reports/subReports/marginPark/income.svg";
import MarginParkSearch from "Assets/Images/Reports/subReports/marginPark/search.svg";
import MarginParkDensity from "Assets/Images/Reports/subReports/marginPark/density.svg";

import EventsGeneral from "Assets/Images/Reports/subReports/events/general.svg";
import EventsPeriod from "Assets/Images/Reports/subReports/events/period.svg";
import EventsStatus from "Assets/Images/Reports/subReports/events/status.svg";

import CurrentSituationImage from "Assets/Images/Reports/subReports/plate/currentـsituation.svg";
import StatisticsImage from "Assets/Images/Reports/subReports/plate/Combo_Chart.svg";
import ComparisonImage from "Assets/Images/Reports/subReports/plate/comparing.svg";
import OcrImage from "Assets/Images/Reports/subReports/plate/ocr.svg";
import PlaqueImage from "Assets/Images/Reports/subReports/plate/plaque.svg";
import CompanyImage from "Assets/Images/Reports/subReports/plate/company.svg";
import Monitoring from "Assets/Images/Reports/subReports/plate/monitoring.svg";
import BrandsImage from "Assets/Images/Reports/subReports/plate/office.svg";
import ViolationsImage from "Assets/Images/Reports/subReports/plate/police.svg";

// export const SUB_REPORT_DATA = [
//   { value: "1", src: CurrentSituationImage, text: "وضعیت لحظه‌ای" },
//   { value: "2", src: StatisticsImage, text: " آماری" },
//   { value: "3", src: ComparisonImage, text: " مقایسه‌ای" },
//   { value: "4", src: OcrImage, text: " بررسی OCR" },
//   { value: "5", src: PlaqueImage, text: "جستجوی پلاک" },
//   { value: "6", src: CompanyImage, text: "مقایسه شرکت‌ها" },
//   { value: "7", src: SystemsImage, text: "مانیتورینگ سامانه‌ها" },
//   { value: "8", src: BrandsImage, text: "مقایسه برندها" },
//   { value: "9", src: ViolationsImage, text: " تخلفات" },
// ];

export const REPORT_DATA = [
  {
    value: 1,
    src: TaxiImage,
    text: " تاکسی",
    items: [
      {
        value: "1",
        src: TaxiGeneralStatistics,
        text: " آمار کلی تاکسی‌ها",
        url: "https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=192268ba-27a2-4e54-bcc0-dfebc4e59cdb",
      },
      {
        value: "2",
        src: Taxierformance,
        text: " میزان کارکرد تاکسی ها",
        url: "https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=9dcde2f8-18c0-45ab-bbdd-80846265c223",
      },

      {
        value: "3",
        src: TaxiDriver,
        text: "پروفایل رانندگان",
        url: "https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=8a66059d-6034-474a-8592-509db513ce1f",
      },
      { value: "4", src: TaxiActivity, text: "فعالیت تاکسی‌ها در شهر" },
      { value: "5", src: TaxiTravels, text: "سفرهای تاکسی‌ها" },
      { value: "6", src: TaxiLineStatus, text: "وضعیت خطوط تاکسی ها" },
      { value: "7", src: TaxiBestDrivers, text: "برترین رانندگان" },
      { value: "8", src: TaxiCircle, text: "آماری تاکسی‌های گردشی" },
      { value: "9", src: PlusImage },
    ],
  },
  {
    value: 2,
    src: BusImage,
    text: " اتوبوس",
    items: [
      {
        value: 1,
        src: DoughnutChart,
        text: "آماری کلی اتوبوس‌ها",
        url: 'https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=e22d3d2e-4e84-4960-ab3d-cabe49f2a4c5&paramvalues={"13ae7ac4-0468-6591-5a74-3eeac84bb794":[{"Value":{"Id":null,"Value":"2024-06-24T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}],"ebed10c2-460f-66ef-a057-48f79372aea5":[{"Value":{"Id":null,"Value":"2024-07-03T00:00:00","DisplayValue":null},"FromColumn":false,"SelectedField":null}]}',
      },
      { value: 2, src: Timezone, text: "وضعیت لحظه‌ای خطوط" },
      { value: 3, src: TimelineSlider, text: "زمان سفر نیم‌راه‌ها" },
      {
        value: 4,
        src: Polyline,
        text: "پروفایل خطوط",
        url: 'https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=e46a3bad-d225-40d0-a469-70047f09b7fd&paramvalues={"9a185c57-160e-4013-06ca-0d4e01fe6072":[{"Value":{"Id":"94","Value":"94","DisplayValue":"94"},"FromColumn":false,"SelectedField":null}],"e3d270d2-02cb-8ff1-a7ab-e25616eb604c":[{"Value":{"Id":"رفت","Value":"رفت","DisplayValue":"رفت"},"FromColumn":false,"SelectedField":null}]}',
      },
      { value: 5, src: MapPinpoint, text: "ماتریس مبدا و مقصد" },
      { value: 6, src: Traveler, text: "گزارشات ساعتی مسافران" },
      { value: "7", src: PlusImage },
      { value: "8", src: PlusImage },
      { value: "9", src: PlusImage },
    ],
  },
  {
    value: 3,
    src: SubwayImage,
    text: " مترو",
    items: [
      {
        value: 1,
        src: MetroStatistics,
        text: "آمار جابه‌جایی مسافران",
        url: "https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=3982487c-deb3-41c2-88a1-17edab7b4387",
      },
      { value: 2, src: MetroLineProfile, text: "پروفایل خطوط" },
      { value: 3, src: MetroCompare, text: "مقایسه ایستگاه‌ها" },
      { value: 4, src: MetroMonitoring, text: "مانیتورینگ" },
      { value: 5, src: MetroTime, text: "زمان سفر" },
      { value: 6, src: MetroSrcDes, text: "مبدا و مقصد مسافران" },
      { value: "7", src: PlusImage },
      { value: "8", src: PlusImage },
      { value: "9", src: PlusImage },
    ],
  },
  {
    value: 4,
    src: RatingImage,
    text: " سفرها",
    items: [
      { value: 1, src: TravelReportMatris, text: "ماتریس سفر ناوگان شخصی" },
      { value: 2, src: TravelReporRequest, text: "تقاضی سفر مسافران" },
      { value: 3, src: TravelReporTime, text: "زمان سفر بین مناطق" },
      { value: 4, src: TravelReporBus, text: "سفر با اتوبوس" },
      { value: 5, src: PlusImage },
      { value: 6, src: PlusImage },
      { value: "7", src: PlusImage },
      { value: "8", src: PlusImage },
      { value: "9", src: PlusImage },
    ],
  },
  {
    value: 5,
    src: TrafficImage,
    text: " تحلیل زمان سفر و ترافیک",
    items: [
      {
        value: 1,
        src: TrafficAndTravelTraffic,
        text: "وضعیت لحظه‌ای ترافیک",
        url: "https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=5196acca-de07-49ae-b520-d9e3da6e095b",
      },
      { value: 2, src: TrafficAndTravelTime, text: "تغییرات زمان سفر معابر" },
      { value: 3, src: TrafficAndTravelVoluminousPassges, text: "پرحجم‌ترین معابر" },
      { value: 4, src: TrafficAndTravelPredictTime, text: "پیش‌بینی زمان سفر" },
      { value: 5, src: TrafficAndTravelPassageProfile, text: "پروفایل معابر" },
      { value: 6, src: PlusImage },
      { value: "7", src: PlusImage },
      { value: "8", src: PlusImage },
      { value: "9", src: PlusImage },
    ],
  },
  {
    value: 6,
    src: CameraImage,
    text: "سامانه پلاکخوان",
    items: [
      { value: "1", src: CurrentSituationImage, text: "وضعیت لحظه‌ای" },
      {
        value: "2",
        src: StatisticsImage,
        text: " آماری",
        url: "https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=c8eeffc8-676d-42d2-8599-0834684dcb69",
      },
      {
        value: "3",
        src: ComparisonImage,
        text: " مقایسه‌ای",
        url: "https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=00606339-8bd7-44dc-971a-e139afdc93a0",
      },
      {
        value: "4",
        src: OcrImage,
        text: " بررسی OCR",
        url: "https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=08682b16-ed87-45c8-be3f-e4aad1292106",
      },
      { value: "5", src: PlaqueImage, text: "جستجوی پلاک" },
      {
        value: "6",
        src: CompanyImage,
        text: "مقایسه شرکت‌ها",
        url: "https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=613f3f04-f629-4d0e-af53-1007e4a77ccb",
      },
      { value: "7", src: Monitoring, text: "مانیتورینگ سامانه‌ها" },
      {
        value: "8",
        src: BrandsImage,
        text: "مقایسه برندها",
        url: "https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=5bd5344a-80c9-4361-9f34-126a7c06db45",
      },
      { value: "9", src: ViolationsImage, text: " تخلفات" },
    ],
  },
  {
    value: 7,
    src: CrossRoadImage,
    text: " تقاطع‌ها و مسیر سبز",
    items: [
      { value: 1, src: CrossMoment, text: "وضعیت لحظه‌ای تقاطع‌ها" },
      { value: 2, src: CrossStopstatistics, text: "آمار توقف در تقاطع" },
      { value: 3, src: CrossStopTime, text: "زمان توقف در تقاطع‌ها" },
      { value: 4, src: PlusImage },
      { value: 5, src: PlusImage },
      { value: 6, src: PlusImage },
      { value: "7", src: PlusImage },
      { value: "8", src: PlusImage },
      { value: "9", src: PlusImage },
    ],
  },
  {
    value: 8,
    src: ParkingImage,
    text: " پارک حاشیه‌ای",
    items: [
      {
        value: 1,
        src: MarginParkGeneral,
        text: "وضعیت کلی پارک حاشیه‌ای",
        url: "https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=558b06a0-6092-44e0-ba4d-3d2e8686ed76",
      },
      { value: 2, src: MarginParkPassage, text: "پارک حاشیه ای به تفکیک معابر" },
      { value: 3, src: MarginParkIncome, text: "گزارشات درآمدی" },
      { value: 4, src: MarginParkSearch, text: "جستجوی خودرو خاص" },
      { value: 5, src: MarginParkDensity, text: "تراکم در نقاط" },
      { value: 6, src: PlusImage },
      { value: "7", src: PlusImage },
      { value: "8", src: PlusImage },
      { value: "9", src: PlusImage },
    ],
  },
  {
    value: 9,
    src: AccidentImage,
    text: " حوادث",
    items: [
      {
        value: 1,
        src: EventsGeneral,
        text: "آمار رخدادها",
        url: "https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=da4e3cf5-9b83-4ac2-b363-3e940ceea0bc",
      },
      { value: 2, src: EventsPeriod, text: "آمار دوره‌ای رخدادها" },
      { value: 3, src: EventsStatus, text: "وضعیت رخدادها" },
      { value: 4, src: PlusImage },
      { value: 5, src: PlusImage },
      { value: 6, src: PlusImage },
      { value: "7", src: PlusImage },
      { value: "8", src: PlusImage },
      { value: "9", src: PlusImage },
    ],
  },
];

// const companies = [
//   { name: "مگفا", code: 12 },
//   { name: "گصن", code: 10 },
//   { name: "داتیس", code: 9 },
// ];

// const filteredCompanies = companies.filter((c) => c.code === systems[0].companyCode);

// for (let i = 0; i < system.length; i += 1) {}
// const allSystems = [
//   {
//     sysName: "طرح کنترل الودگی",
//     sysCode: 32,
//     companyName: "مگفا",
//     companyCode: 12,
//   },
//   {
//     sysName: "طرح ترافیک",
//     sysCode: 29,
//     companyName: "مگفا",
//     companyCode: 12,
//   },
//   {
//     sysName: "ثبت تخلف سرعت",
//     sysCode: 28,
//     companyName: "گصن",
//     companyCode: 10,
//   },
//   {
//     sysName: "ثبت تخلف چراغ قرمز",
//     sysCode: 20,
//     companyName: "داتیس",
//     companyCode: 9,
//   },
//   {
//     sysName: "پلاک خوان مسیر ویژه اتوبوس",
//     sysCode: 26,
//     companyName: "داتیس",
//     companyCode: 9,
//   },
//   {
//     sysName: "پلاک خوان لاین اضطرار",
//     sysCode: 27,
//     companyName: "داتیس",
//     companyCode: 9,
//   },
//   {
//     sysName: "پلاک خوان رینگ تهران",
//     sysCode: 30,
//     companyName: "داتیس",
//     companyCode: 9,
//   },
//   {
//     sysName: "پلاک خوان خودرو سنگین",
//     sysCode: 25,
//     companyName: "داتیس",
//     companyCode: 9,
//   },
//   {
//     sysName: "پلاک خوان تره بار",
//     sysCode: 21,
//     companyName: "داتیس",
//     companyCode: 9,
//   },
//   {
//     sysName: "پلاک خوان تاکسیرانی",
//     sysCode: 24,
//     companyName: "داتیس",
//     companyCode: 9,
//   },
//   {
//     sysName: "پلاک خوان بهشت زهرا",
//     sysCode: 22,
//     companyName: "داتیس",
//     companyCode: 9,
//   },
// ];
